/* Kartograf · «Inventati qualcosa»: generatore procedurale di grafiche SVG, gratis, senza API.
   Nome + numero + stile → 4 grafiche con font Google, scudi, archi di testo, numeri, linee, stelle.
   Colori scelti per contrasto (WCAG) col colore del capo. Variazioni casuali a ogni «Altre idee». */
(function () {
  var KG = window.KG = window.KG || {};

  var FAMIGLIE = 'family=Anton&family=Bebas+Neue&family=Montserrat:wght@500;800&family=Permanent+Marker&family=Playfair+Display:ital,wght@0,700;1,700';
  KG.FONT_CSS_URL = 'https://fonts.googleapis.com/css2?' + FAMIGLIE + '&display=swap';

  /* font incorporati nell'SVG (base64), così l'SVG si vede uguale anche come immagine e nel file scaricato */
  var fontPromise = null;
  KG.fontIncorporati = function () {
    if (fontPromise) return fontPromise;
    fontPromise = fetch(KG.FONT_CSS_URL).then(function (r) { return r.text(); }).then(function (css) {
      var blocchi = css.match(/\/\*\s*latin\s*\*\/\s*@font-face\s*{[^}]*}/g) || [];
      return Promise.all(blocchi.map(function (b) {
        var m = b.match(/url\((https:[^)]+)\)/);
        if (!m) return Promise.resolve('');
        return fetch(m[1]).then(function (r) { return r.blob(); }).then(function (bl) {
          return new Promise(function (ok) {
            var fr = new FileReader(); fr.onload = function () { ok(b.replace(m[1], fr.result)); }; fr.readAsDataURL(bl);
          });
        });
      })).then(function (arr) { return arr.join('\n'); });
    }).catch(function () { return ''; });
    return fontPromise;
  };

  // ---- colori ----
  var INCHIOSTRI = [
    { n: 'Bianco', c: '#ffffff' }, { n: 'Nero', c: '#111111' }, { n: 'Rosso', c: '#FB0102' },
    { n: 'Oro', c: '#D4A72C' }, { n: 'Blu', c: '#1d3fae' }, { n: 'Argento', c: '#c3c7cc' }, { n: 'Giallo', c: '#FFD400' }
  ];
  function hexRgb(h) { h = h.replace('#', ''); return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)]; }
  function rgbHex(c) { return '#' + c.map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join(''); }
  function lumRel(c) { var a = c.map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }); return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2]; }
  function contrasto(a, b) { var l1 = lumRel(a), l2 = lumRel(b); return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05); }
  KG.contrasto = contrasto;

  function rng(seed) { var s = seed >>> 0 || 1; return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }; }
  function scegli(r, arr) { return arr[Math.floor(r() * arr.length)]; }
  function mescola(r, arr) { arr = arr.slice(); for (var i = arr.length - 1; i > 0; i--) { var j = Math.floor(r() * (i + 1)); var t = arr[i]; arr[i] = arr[j]; arr[j] = t; } return arr; }

  KG.tavolozza = function (capoRgb, r) {
    var ord = INCHIOSTRI.map(function (k) { return { n: k.n, c: k.c, k: contrasto(hexRgb(k.c), capoRgb) }; })
      .sort(function (a, b) { return b.k - a.k; });
    var top = ord.filter(function (o) { return o.k >= Math.max(3, ord[0].k * 0.55); });
    var main = r() < 0.75 ? top[0] : scegli(r, top);
    var acc = ord.filter(function (o) { return o.c !== main.c && o.k >= 2.2; });
    var rosso = acc.filter(function (o) { return o.n === 'Rosso'; })[0];
    var a = (rosso && r() < 0.65) ? rosso : (acc.length ? scegli(r, acc.slice(0, 3)) : main);
    var mainRgb = hexRgb(main.c);
    var su = INCHIOSTRI.concat([{ n: 'Capo', c: rgbHex(capoRgb) }]).map(function (k) { return { c: k.c, k: contrasto(hexRgb(k.c), mainRgb) }; })
      .sort(function (x, y) { return y.k - x.k; })[0].c;
    var accSu = contrasto(hexRgb(a.c), mainRgb) >= 2 ? a.c : su;
    return { capo: rgbHex(capoRgb), main: main.c, acc: a.c, su: su, accSu: accSu, nomi: [main.n, a.n] };
  };

  // ---- utilità SVG ----
  function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var LARG = { Anton: 0.5, 'Bebas Neue': 0.42, Montserrat: 0.72, 'Permanent Marker': 0.62, 'Playfair Display': 0.6 };
  function misura(testo, font, max, spazio) { // dimensione del font perché il testo stia in "max" px
    var n = Math.max(1, testo.length), f = LARG[font] || 0.6;
    return max / (n * f + (n - 1) * (spazio || 0));
  }
  function stella(cx, cy, r, colore) {
    var p = [];
    for (var i = 0; i < 10; i++) { var a = -Math.PI / 2 + i * Math.PI / 5, rr = i % 2 ? r * 0.45 : r; p.push((cx + rr * Math.cos(a)).toFixed(1) + ',' + (cy + rr * Math.sin(a)).toFixed(1)); }
    return '<polygon points="' + p.join(' ') + '" fill="' + colore + '"/>';
  }
  function stelle(n, cx, cy, gap, r, colore) { var s = ''; for (var i = 0; i < n; i++) s += stella(cx + (i - (n - 1) / 2) * gap, cy, r, colore); return s; }
  function testo(t, x, y, font, size, fill, extra) {
    return '<text x="' + x + '" y="' + y + '" font-family="\'' + font + '\'" font-size="' + size.toFixed(1) + '" fill="' + fill + '" text-anchor="middle" ' + (extra || '') + '>' + esc(t) + '</text>';
  }
  var uid = 0;
  function arco(t, cx, cy, r, sopra, font, size, fill, spazio, extra) {
    var id = 'a' + (++uid) + Math.floor(Math.random() * 1e6);
    var d = sopra ? 'M' + (cx - r) + ',' + cy + ' A' + r + ',' + r + ' 0 0 1 ' + (cx + r) + ',' + cy
      : 'M' + (cx - r) + ',' + cy + ' A' + r + ',' + r + ' 0 0 0 ' + (cx + r) + ',' + cy;
    return { defs: '<path id="' + id + '" d="' + d + '" fill="none"/>',
      body: '<text font-family="\'' + font + '\'" font-size="' + size.toFixed(1) + '" fill="' + fill + '" letter-spacing="' + ((spazio || 0) * size).toFixed(1) + '" ' + (extra || '') + '><textPath href="#' + id + '" startOffset="50%" text-anchor="middle">' + esc(t) + '</textPath></text>' };
  }
  function iniziali(nome) {
    var p = nome.trim().split(/\s+/).filter(Boolean);
    return (p.length > 1 ? p[0][0] + p[1][0] : p[0].slice(0, 2)).toUpperCase();
  }
  function avvolgi(w, h, defs, body, css) {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + w + ' ' + h + '" width="' + w + '" height="' + h + '"><defs><style>' + (css || '') + '</style>' + defs + '</defs>' + body + '</svg>';
  }

  // ---- modelli ----
  var SCUDO = 'M300 150 L470 196 L462 360 Q446 470 300 532 Q154 470 138 360 L130 196 Z';
  var MODELLI = {
    Sportivo: [
      function scudo(d, P, r) {
        var N = d.nome.toUpperCase(), f = scegli(r, ['Anton', 'Bebas Neue']);
        var a = arco(N, 300, 330, 215, true, f, Math.min(74, misura(N, f, 560, 0.08)), P.main, 0.08);
        var centro = d.numero || iniziali(d.nome);
        var body = a.body + '<path d="' + SCUDO + '" fill="' + P.main + '"/>' +
          '<path d="' + SCUDO + '" fill="none" stroke="' + P.accSu + '" stroke-width="9" transform="translate(300 340) scale(.86) translate(-300 -340)"/>' +
          stelle(3, 300, 240, 46, 15, P.accSu) +
          testo(centro, 300, 460, 'Anton', centro.length > 2 ? 150 : 200, P.su);
        return avvolgi(600, 560, a.defs, body);
      },
      function varsity(d, P, r) {
        var N = d.nome.toUpperCase(), f = scegli(r, ['Bebas Neue', 'Anton']);
        var size = Math.min(130, misura(N, f, 560, 0.04)), D = Math.round(size * 0.95);  // D: spazio sopra l'arco, niente lettere tagliate
        var a = arco(N, 300, 330, 300, true, f, size, P.main, 0.04, 'stroke="' + P.acc + '" stroke-width="' + (size * 0.05).toFixed(1) + '" paint-order="stroke"');
        var body = a.body + stelle(r() < 0.5 ? 3 : 5, 300, 250, 40, 13, P.acc);
        if (d.numero) body += testo(d.numero, 300, 520, 'Anton', 250, P.acc, 'stroke="' + P.main + '" stroke-width="10" paint-order="stroke"');
        else body += '<rect x="150" y="300" width="300" height="10" fill="' + P.acc + '"/>';
        return avvolgi(600, (d.numero ? 560 : 340) + D - 20, a.defs, '<g transform="translate(0 ' + (D - 20) + ')">' + body + '</g>');
      },
      function tondo(d, P, r) {
        var N = d.nome.toUpperCase(), f = scegli(r, ['Bebas Neue', 'Anton']);
        var a = arco(N, 300, 300, 172, true, f, Math.min(62, misura(N, f, 470, 0.1)), P.main, 0.1);
        var centro = d.numero || iniziali(d.nome);
        var body = '<circle cx="300" cy="300" r="270" fill="none" stroke="' + P.main + '" stroke-width="14"/>' +
          '<circle cx="300" cy="300" r="246" fill="none" stroke="' + P.acc + '" stroke-width="5"/>' +
          '<circle cx="300" cy="300" r="150" fill="none" stroke="' + P.main + '" stroke-width="4"/>' + a.body +
          testo(centro, 300, 352, 'Anton', centro.length > 2 ? 120 : 160, P.main) +
          stelle(3, 300, 470, 48, 16, P.acc);
        return avvolgi(600, 600, a.defs, body);
      },
      function diagonale(d, P, r) {
        var N = d.nome.toUpperCase(), size = Math.min(150, misura(N, 'Bebas Neue', 470, 0.02));
        var body = '<g transform="skewX(-12) translate(70 0)">' +
          '<rect x="40" y="150" width="90" height="14" fill="' + P.acc + '"/><rect x="10" y="185" width="120" height="14" fill="' + P.acc + '"/><rect x="60" y="220" width="70" height="14" fill="' + P.acc + '"/>' +
          testo(N, 340, 240, 'Bebas Neue', size, P.main, 'letter-spacing="2"') +
          '<rect x="150" y="262" width="380" height="8" fill="' + P.main + '"/>' +
          (d.numero ? testo(d.numero, 340, 420, 'Anton', 150, P.acc) : stelle(5, 340, 320, 40, 13, P.acc)) + '</g>';
        return avvolgi(640, d.numero ? 440 : 360, '', body);
      }
    ],
    Elegante: [
      function monogramma(d, P, r) {
        var I = iniziali(d.nome), N = d.nome.toUpperCase();
        var body = '<circle cx="300" cy="250" r="190" fill="none" stroke="' + P.main + '" stroke-width="3"/>' +
          '<circle cx="300" cy="250" r="176" fill="none" stroke="' + P.main + '" stroke-width="1"/>' +
          testo(I, 300, 310, 'Playfair Display', 170, P.main, 'font-style="italic" font-weight="700"') +
          '<rect x="296" y="62" width="9" height="9" transform="rotate(45 300 66)" fill="' + P.acc + '"/>' +
          testo(N, 300, 520, 'Montserrat', Math.min(34, misura(N, 'Montserrat', 520, 0.35)), P.main, 'font-weight="500" letter-spacing="' + (0.35 * 30).toFixed(0) + '"') +
          (d.numero ? testo('N° ' + d.numero, 300, 570, 'Montserrat', 24, P.acc, 'font-weight="500" letter-spacing="6"') : '');
        return avvolgi(600, d.numero ? 600 : 550, '', body);
      },
      function linee(d, P, r) {
        var N = d.nome, size = Math.min(110, misura(N, 'Playfair Display', 540, 0));
        var body = '<rect x="60" y="120" width="210" height="2" fill="' + P.main + '"/><rect x="330" y="120" width="210" height="2" fill="' + P.main + '"/>' +
          '<rect x="292" y="113" width="16" height="16" transform="rotate(45 300 121)" fill="' + P.acc + '"/>' +
          testo(N, 300, 160 + size * 0.75, 'Playfair Display', size, P.main, 'font-weight="700"') +
          '<rect x="60" y="' + (200 + size * 0.75) + '" width="480" height="2" fill="' + P.main + '"/>' +
          (d.numero ? testo('— ' + d.numero + ' —', 300, 262 + size * 0.75, 'Montserrat', 30, P.acc, 'font-weight="500" letter-spacing="8"') : '');
        return avvolgi(600, 290 + size * 0.75, '', body);
      },
      function stemma(d, P, r) {
        var I = iniziali(d.nome), N = d.nome.toUpperCase(), foglie = '';
        for (var i = 0; i < 6; i++) {
          var y = 430 - i * 46, x = 150 - Math.sin(i / 5 * Math.PI) * 30;
          foglie += '<ellipse cx="' + x + '" cy="' + y + '" rx="11" ry="25" transform="rotate(' + (-30 + i * 6) + ' ' + x + ' ' + y + ')" fill="' + P.acc + '"/>';
          foglie += '<ellipse cx="' + (600 - x) + '" cy="' + y + '" rx="11" ry="25" transform="rotate(' + (30 - i * 6) + ' ' + (600 - x) + ' ' + y + ')" fill="' + P.acc + '"/>';
        }
        var body = foglie + '<path d="' + SCUDO + '" transform="translate(300 330) scale(.72) translate(-300 -330)" fill="none" stroke="' + P.main + '" stroke-width="5"/>' +
          testo(I, 300, 395, 'Playfair Display', 120, P.main, 'font-weight="700"') +
          testo(N, 300, 560, 'Montserrat', Math.min(34, misura(N, 'Montserrat', 520, 0.3)), P.main, 'font-weight="800" letter-spacing="9"') +
          (d.numero ? testo(d.numero, 300, 180, 'Playfair Display', 34, P.acc, 'font-style="italic" font-weight="700"') : '');
        return avvolgi(600, 590, '', body);
      },
      function firma(d, P, r) {
        var N = d.nome, size = Math.min(120, misura(N, 'Playfair Display', 520, 0));
        var body = testo(N, 300, 70 + size, 'Playfair Display', size, P.main, 'font-style="italic" font-weight="700"') +
          '<path d="M90 ' + (105 + size) + ' Q300 ' + (150 + size) + ' 520 ' + (95 + size) + '" fill="none" stroke="' + P.acc + '" stroke-width="7" stroke-linecap="round"/>' +
          testo((d.numero ? d.numero + ' · ' : '') + '★', 300, 190 + size, 'Montserrat', 26, P.main, 'font-weight="500" letter-spacing="10"');
        return avvolgi(600, 220 + size, '', body);
      }
    ],
    Street: [
      function tag(d, P, r) {
        var N = d.nome, size = Math.min(130, misura(N, 'Permanent Marker', 520, 0)), gocce = '';
        for (var i = 0; i < 5; i++) { var x = 120 + r() * 360, h = 20 + r() * 50; gocce += '<rect x="' + x + '" y="' + (150 + size * 0.6) + '" width="7" height="' + h + '" rx="3" fill="' + P.main + '"/><circle cx="' + (x + 3.5) + '" cy="' + (150 + size * 0.6 + h) + '" r="6" fill="' + P.main + '"/>'; }
        var body = '<g transform="rotate(-7 300 200)">' + testo(N, 300, 120 + size * 0.55, 'Permanent Marker', size, P.main) + gocce +
          '<path d="M70 ' + (180 + size * 0.7) + ' C200 ' + (140 + size * 0.7) + ' 380 ' + (230 + size * 0.7) + ' 540 ' + (160 + size * 0.7) + '" fill="none" stroke="' + P.acc + '" stroke-width="16" stroke-linecap="round"/>' +
          (d.numero ? testo(d.numero, 500, 95, 'Permanent Marker', 70, P.acc) : '') + '</g>';
        return avvolgi(600, 300 + size * 0.7, '', body);
      },
      function pila(d, P, r) {
        var parole = d.nome.toUpperCase().split(/\s+/).filter(Boolean).slice(0, 3), y = 40, body = '';
        if (d.numero) parole.push(d.numero);
        parole.forEach(function (w, i) {
          var size = Math.min(170, misura(w, 'Anton', 500, 0.02)); y += size * 0.95;
          var pieno = i % 2 === 0;
          body += testo(w, 308, y + 8, 'Anton', size, P.acc);
          body += testo(w, 300, y, 'Anton', size, pieno ? P.main : 'none', pieno ? '' : 'stroke="' + P.main + '" stroke-width="5"');
          y += 14;
        });
        return avvolgi(600, y + 30, '', body);
      },
      function adesivo(d, P, r) {
        var N = d.nome.toUpperCase(), size = Math.min(110, misura(N, 'Anton', 440, 0.02));
        var body = '<g transform="rotate(' + (-8 + r() * 4).toFixed(1) + ' 300 220)"><rect x="60" y="120" width="480" height="200" rx="34" fill="' + P.main + '"/>' +
          '<rect x="76" y="136" width="448" height="168" rx="24" fill="none" stroke="' + P.accSu + '" stroke-width="4" stroke-dasharray="14 10"/>' +
          testo(N, 300, 220 + size * 0.36, 'Anton', size, P.su) + '</g>' +
          (d.numero ? '<circle cx="500" cy="110" r="62" fill="' + P.acc + '"/>' + testo(d.numero, 500, 135, 'Anton', 70, contrasto(hexRgb(P.acc), [255, 255, 255]) > 3 ? '#ffffff' : '#111111') : stella(505, 110, 52, P.acc));
        return avvolgi(600, 400, '', body);
      },
      function timbro(d, P, r) {
        var N = d.nome.toUpperCase(), buchi = '';
        var a = arco(N, 300, 300, 200, true, 'Bebas Neue', Math.min(80, misura(N, 'Bebas Neue', 560, 0.12)), P.main, 0.12);
        var b = arco(d.numero ? '★ ' + d.numero + ' ★' : '★ ★ ★', 300, 300, 230, false, 'Bebas Neue', 60, P.main, 0.2);
        for (var i = 0; i < 160; i++) buchi += '<circle cx="' + (r() * 600).toFixed(0) + '" cy="' + (r() * 600).toFixed(0) + '" r="' + (1 + r() * 4).toFixed(1) + '" fill="#000"/>';
        var mid = 'usura' + Math.floor(r() * 1e9);
        var defs = a.defs + b.defs + '<mask id="' + mid + '"><rect width="600" height="600" fill="#fff"/>' + buchi + '</mask>';
        var body = '<g mask="url(#' + mid + ')"><circle cx="300" cy="300" r="280" fill="none" stroke="' + P.main + '" stroke-width="12"/>' +
          '<circle cx="300" cy="300" r="150" fill="none" stroke="' + P.main + '" stroke-width="5"/>' + a.body + b.body +
          stella(300, 300, 105, P.acc) + '</g>';
        return avvolgi(600, 600, defs, body);
      }
    ]
  };
  KG.STILI = Object.keys(MODELLI);

  /* genera 4 idee: [{svg, nome}] */
  KG.generaIdee = function (dati, capoRgb, seed) {
    var r = rng(seed || Date.now());
    var nome = (dati.nome || '').trim() || 'Kartograf';
    var numero = String(dati.numero || '').replace(/[^0-9]/g, '').slice(0, 3);
    var lista = mescola(r, MODELLI[dati.stile] || MODELLI.Sportivo);
    return lista.slice(0, 4).map(function (fn, i) {
      var P = KG.tavolozza(capoRgb, r);
      return { svg: fn({ nome: nome.slice(0, 22), numero: numero }, P, r), nome: dati.stile + ' ' + (i + 1), colori: P.nomi };
    });
  };

  /* aggiunge i font incorporati e trasforma l'SVG in canvas (diventa il "logo") */
  KG.svgConFont = function (svg, css) { return svg.replace('<style></style>', '<style>' + css + '</style>'); };
  KG.svgInCanvas = function (svg, larghezza) {
    return new Promise(function (ok, ko) {
      var img = new Image();
      img.onload = function () {
        var w = larghezza || 1400, h = Math.round(w * img.height / img.width);
        var c = KG.nuovoCanvas(w, h); c.getContext('2d').drawImage(img, 0, 0, w, h); ok(c);
      };
      img.onerror = ko;
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    });
  };
})();
